/**
 * The step sequence, in one place so the shell can render progress without
 * importing the router module that renders the steps (which would be circular).
 *
 * Steps are addressed by NUMBER in the URL (`/:teamId/form/2`), not by name.
 * A customer glancing at the address bar gets "2 of 6" rather than a word that
 * means something to us and nothing to them, and renaming or reordering a step
 * no longer changes anybody's saved link.
 *
 * The photo step sits last before review on purpose: a customer who runs out of
 * time has by then already given the shop everything it needs to make contact.
 */
export const STEPS = [
  { key: 'contact', label: 'Your details' },
  { key: 'vehicle', label: 'Vehicle' },
  { key: 'damage', label: 'Damage' },
  { key: 'workshop', label: 'In the workshop' },
  { key: 'photos', label: 'Photos' },
  { key: 'review', label: 'Review' }
];

/** 1-based step number for a key, or 1 if the key is unknown. */
export function stepNumber(key) {
  const index = STEPS.findIndex((step) => step.key === key);
  return index === -1 ? 1 : index + 1;
}

/** Zero-based index from a URL segment; -1 when it isn't a step. */
export function stepIndexFromParam(param) {
  const number = parseInt(param, 10);
  if (!Number.isFinite(number) || number < 1 || number > STEPS.length) return -1;
  return number - 1;
}

/**
 * Build a step URL, carrying the quote request id once there is one.
 *
 * The id in the address bar is what lets a customer return to the same
 * submission from a bookmark or a link they sent themselves, rather than
 * depending on this browser's storage.
 */
export function stepPath(teamId, key, quoteRequestId) {
  const base = `/${teamId}/form/${stepNumber(key)}`;
  return quoteRequestId ? `${base}?q=${quoteRequestId}` : base;
}

export default STEPS;
